import { Button } from 'ui/button';
import { Modal, MODAL_SIZES, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

interface ResendConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  recipient: string;
  campaignName: string;
}

export const ResendConfirmationModal = ({
  isOpen,
  onClose,
  onSubmit,
  recipient,
  campaignName,
}: ResendConfirmationModalProps) => (
  <Modal
    id="resend-message-confirmation-modal"
    isModalOpen={isOpen}
    onClose={onClose}
    size={MODAL_SIZES.SMALL}
  >
    <ModalHeader onClose={onClose}>Resend message</ModalHeader>
    <ModalBody>
      <p>
        You're about to resend this message to <strong>{recipient}</strong> (Campaign:{' '}
        <strong>{campaignName}</strong>). Are you sure you want to send this message?
      </p>
    </ModalBody>
    <ModalFooter onClose={onClose}>
      <Button onClick={onSubmit}>Resend</Button>
    </ModalFooter>
  </Modal>
);
